import { computed } from 'vue'
import { useHead } from '@unhead/vue'
import { useRoute, type RouteLocationNormalizedLoaded } from 'vue-router'

declare module 'vue-router' {
  interface RouteMeta {
    title?: string | ((route: RouteLocationNormalizedLoaded) => string)
  }
}

export const DEFAULT_TITLE = 'Dacr | The Global Standard for Copyright'

export const folderTitle = (route: RouteLocationNormalizedLoaded) => {
  const path = route.params.path
  return (Array.isArray(path) ? path.at(-1) : path) || 'Home'
}

export const fileSearchTitle = (route: RouteLocationNormalizedLoaded) =>
  `Search results in your files for "${route.query.query ?? ''}"`

export const publicSearchTitle = (route: RouteLocationNormalizedLoaded) =>
  `Search results in Dacr public files for "${route.query.query ?? ''}"`

export function useRouteTitle() {
  const route = useRoute()

  useHead({
    title: computed(() => {
      const title =
        typeof route.meta.title === 'function'
          ? route.meta.title(route)
          : route.meta.title
      return title ? `${title} | Dacr` : DEFAULT_TITLE
    }),
  })
}
